import { render, staticRenderFns } from "./AmazonBalance.vue?vue&type=template&id=e18d9d8a&scoped=true&"
import script from "./AmazonBalance.vue?vue&type=script&lang=js&"
export * from "./AmazonBalance.vue?vue&type=script&lang=js&"
import style0 from "./AmazonBalance.vue?vue&type=style&index=0&id=e18d9d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18d9d8a",
  null
  
)

export default component.exports